const dateToSeoFormat = (couldBeDate?: Date | string | null): string => {
    if (typeof couldBeDate === 'undefined' || couldBeDate === null) return new Date().toISOString()
    if (typeof couldBeDate === 'string' && couldBeDate.length === 0) return new Date().toISOString()
    if (typeof couldBeDate === 'string') return new Date(couldBeDate).toISOString()
    if (couldBeDate instanceof Date) return couldBeDate.toISOString()
    return new Date().toISOString()
}

export default dateToSeoFormat
